import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {AuthenticationService} from '@services/authentification.service';
import {MatDialog} from '@angular/material/dialog';
import {EMPTY_LOT} from '@models/empty';

@Component({
    selector: 'app-verif-data',
    templateUrl: './verif-data.component.html',
    styleUrls: ['./verif-data.component.scss']
})
export class VerifDataComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();
    @Output() extChange = new EventEmitter();

    amount_rent_year = 0;
    updateRentYear = null;
    isLogin = false;
    detailLot = false;
    splitLot = false;

    constructor(public cityService: CityService,
                public adService: AdService,
                public commonService: CommonService,
                public authenticationService: AuthenticationService,
                public dialog: MatDialog) {
    }

    ngOnInit(): void {
        this.isLogin = this.authenticationService.isLogin;
        this.amount_rent_year = this.favorite.amount_rent * 12;
        if (this.favorite.lots.length > 1) {
            this.splitLot = true;
            this.detailLot = true;
        } else if (this.favorite.nb_lots > 1) {
            this.detailLot = true;
        }

        this.extChange.subscribe(data => {
            this.amount_rent_year = this.favorite.amount_rent * 12;
        });
    }

    edit(event, fields = '') {
        if (fields == 'amount_rent_year') {
            if (this.updateRentYear != null) {
                clearTimeout(this.updateRentYear);
            }

            this.updateRentYear = setTimeout(() => {
                this.favorite.amount_rent = this.amount_rent_year / 12;
                this.favorite = this.adService.updateValues(this.favorite);
                this.favoriteChange.emit();
            }, 1000);
            return;
        } else if (fields == 'amount_rent') {
            this.amount_rent_year = this.favorite.amount_rent * 12;
        }
        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    splitLots() {
        this.favorite = this.adService.splitFavoriteLots(this.favorite);
        this.splitLot = true;
        this.favoriteChange.emit();
    }

    addLot() {
        let lot = Object.assign({}, EMPTY_LOT);
        lot.estate_type = 'Appartement';
        this.favorite.lots.push(lot);
        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    duplicateLot(i) {
        let lot = Object.assign({}, this.favorite.lots[i]);
        this.favorite.lots.push(lot);
        this.favoriteChange.emit();
    }

    deleteLot(i) {
        this.favorite.lots.splice(i, 1);
        if (this.favorite.lots.length <= 1) {
            this.splitLot = false;
            this.detailLot = false;
        }
        this.favorite.nb_lots = this.favorite.lots.length
        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    toogleDetailLot() {
        if (this.detailLot == false) {
            this.splitLot = false;
            this.favorite.nb_lots = 1;
            this.favorite.lots = [{
                title: this.favorite.title,
                nb_lots: this.favorite.nb_lots,
                square: this.favorite.square,
                amount_copro_rent: this.favorite.amount_copro_rent,
                amount_rent: this.favorite.amount_rent,
                advice_rent: this.favorite.advice_rent,
                advice_rent_choice: this.favorite.advice_rent_choice,
                advice_rent_amount: this.favorite.advice_rent_amount,
                advice_rent_L: this.favorite.advice_rent_L,
                advice_rent_U: this.favorite.advice_rent_U,
                advice_rent_cL: this.favorite.advice_rent_cL,
                furnish: this.favorite.furnish,
                estate_type: this.favorite.estate_type,
                rooms: this.favorite.rooms,
                works_help: this.favorite.works_help,
                works_total: this.favorite.works_total,
                works_square_price: this.favorite.works_square_price,
                night_price: 0,
                night_number: 0,
                window: '',
                dpe: '',
                dpe_after: '',
                comment: '',
                heating: ''
            }];
            console.log( this.favorite.lots);
            this.favorite = this.adService.updateValues(this.favorite);
            this.favoriteChange.emit();
        }
    }
}
